import styled from "styled-components";

export const ModalDowloadContent = styled.div`
  padding: 0.5rem;

  h3 {
    font-size: 1.2rem;
    color: #487cf5;
    font-weight: 550;
  }

  p {
    padding: 1rem 0;
    color: #808080;
  }

  div {
    display: flex;
    justify-content: space-between;

    button.dowload {
      background-color: #8fc24c;
      width: 100%;
      padding: 0.3rem 0 0.3rem 0;
      margin: 0 0 0 0.5rem;
      border: 0;
      border-radius: 0.3rem;
      box-shadow: 0px 3px 6px #00000066;
      color: white;
      font-weight: 550;
    }

    button.cancel {
      background-color: #f53832;
      width: 100%;
      padding: 0.3rem 0 0.3rem 0;
      margin: 0 0.5rem 0 0;
      border: 0;
      border-radius: 0.3rem;
      box-shadow: 0px 3px 6px #00000066;
      color: white;
      font-weight: 550;
    }
  }
`;
